const AccountIcon = ({ width = 16, height = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 13C14 10.7909 12.2091 9 10 9H6C3.79086 9 2 10.7909 2 13V14.3333H14V13ZM6 9.66667H10L10.1446 9.66975C11.9185 9.74545 13.3333 11.2075 13.3333 13V13.6667H2.66667V13L2.66975 12.8554C2.74545 11.0815 4.2075 9.66667 6 9.66667Z"
        fill="currentColor"
      />
      <path
        d="M2 14.3333H1.66667V14.6667H2V14.3333ZM14 14.3333V14.6667H14.3333V14.3333H14ZM10 9.66667L10.0071 9.33333H10V9.66667ZM10.1446 9.66975L10.1588 9.33664L10.1517 9.33649L10.1446 9.66975ZM13.3333 13.6667V14H13.6667V13.6667H13.3333ZM2.66667 13.6667H2.33333V14H2.66667V13.6667ZM2.66667 13L2.33333 12.9929V13H2.66667ZM2.66975 12.8554L2.33664 12.8412L2.33649 12.8483L2.66975 12.8554ZM10 9.33333C12.025 9.33333 13.6667 10.975 13.6667 13H14.3333C14.3333 10.6068 12.3932 8.66667 10 8.66667V9.33333ZM6 9.33333H10V8.66667H6V9.33333ZM2.33333 13C2.33333 10.975 3.97496 9.33333 6 9.33333V8.66667C3.60677 8.66667 1.66667 10.6068 1.66667 13H2.33333ZM2.33333 14.3333V13H1.66667V14.3333H2.33333ZM14 14H2V14.6667H14V14ZM13.6667 13V14.3333H14.3333V13H13.6667ZM10 9.33333H6V10H10V9.33333ZM10.1517 9.33649L10.0071 9.33341L9.9929 9.99992L10.1375 10.003L10.1517 9.33649ZM13.6667 13C13.6667 11.0282 12.1103 9.42001 10.1588 9.33672L10.1304 10.0028C11.7266 10.0709 13 11.3868 13 13H13.6667ZM13.6667 13.6667V13H13V13.6667H13.6667ZM2.66667 14H13.3333V13.3333H2.66667V14ZM2.33333 13V13.6667H3V13H2.33333ZM2.33649 12.8483L2.33341 12.9929L2.99992 13.0071L3.003 12.8625L2.33649 12.8483ZM6 9.33333C4.02816 9.33333 2.42001 10.8897 2.33672 12.8412L3.00278 12.8696C3.0709 11.2734 4.38683 10 6 10V9.33333Z"
        fill="currentColor"
      />
      <rect
        x="5.33203"
        y="2"
        width="5.33333"
        height="5.66667"
        rx="2.66667"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
    </svg>
  )
}

export default AccountIcon
